import { render, staticRenderFns } from "./Locationchart.vue?vue&type=template&id=c438d5b4&"
import script from "./Locationchart.vue?vue&type=script&lang=js&"
export * from "./Locationchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports